<template>
  <van-card
    class="doctor-card"
    :tag="imgTag ? '可预约' : ''"
    :thumb="getAvatarUrl(data.headImgUrl)"
    v-if="data"
  >
    <template #title>
      <div class="name">
        {{ data.name }}
        <span class="position">{{
          data.enabledDisplayDutyTitle
            ? data.enabledDisplayDutyTitle
            : professional
        }}</span>
        <!-- <span class="explain">{{ data.LastDate }}</span> -->
      </div>
    </template>
    <!-- <template #desc>
      <div class="rate-box">
        <span class="rate-star">
          <van-rate
            v-model="data.rate"
            :size="16"
            :allowHalf="true"
            :readonly="true"
          />
        </span>
      </div>
    </template> -->
    <template #price>
      <div style="width: 100%">
        <div style="width: 100%">
          <span
            v-if="data.amount && Number(data.amount) > 0"
            style="margin-right: 10px"
          >
            <span style="color: #333">诊查费：</span
            ><span class="price">￥{{ data.amount }}</span>
          </span>
          <span style="color: red">
            <span>{{ data.specializeDirec }}</span>
          </span>
        </div>

        <div class="text-less">
          {{ data.remark }}
        </div>
        <div
          v-if="data.descRemark"
          class="text-less"
          style="color: #323233; font-weight: bold"
        >
          温馨提示：{{ data.descRemark }}
        </div>
      </div>
    </template>
  </van-card>
</template>

<script>
import { Card, Rate } from "vant";
import { getAvatarUrl, cache } from "@/utils/common";
export default {
  name: "DoctorCard",
  components: {
    [Card.name]: Card,
    [Rate.name]: Rate,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    imgTag: {
      type: Boolean,
      default: false,
    },
    enabledDisplayDutyTitle: { type: Boolean, default: false },
  },
  computed: {
    professional() {
      return this.enabledDisplayDutyTitle && this.data.dutyTitle
        ? this.data.dutyTitle
        : this.data.professionalTitle;
    },
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {
    getAvatarUrl,
  },
};
</script>

<style lang="less" scoped>
.doctor-card {
  margin-bottom: 10px;
  .van-card {
    background: #fff;
  }
  .van-card__tag {
    top: initial;
    bottom: 2px;
    font-size: 12px;
  }
  .van-card__content {
    display: inline;
  }
  .name {
    font-weight: bold;
    line-height: 1.6;
    .position,
    .explain {
      font-weight: 400;
      margin-left: 10px;
    }
    .explain {
      float: right;
      color: #1989fa;
    }
  }
  .rate-box {
    .rate-star {
      display: inline-block;
    }
    .rate-number {
      margin-left: 10px;
    }
  }
}
/deep/.van-card__price {
  width: 100%;
}
</style>
